import { render } from "./TestTrumpetStop.vue?vue&type=template&id=26802834&scoped=true"
import script from "./TestTrumpetStop.vue?vue&type=script&lang=js"
export * from "./TestTrumpetStop.vue?vue&type=script&lang=js"

import "./TestTrumpetStop.vue?vue&type=style&index=0&id=26802834&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26802834"]])

export default __exports__